var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  const storeId = selectedStore.storeID;
  console.log(selectedDay, storeId);
  if (storeId === 1447) {
    // Monday
    if(selectedDay === 1) {
      timepicker.set('disable',[{ from: [8, 00], to: [17, 45] }]); 
    }
  
    // Tuesday
    if(selectedDay === 2) {
      timepicker.set('disable',[{ from: [8, 00], to: [17, 45] }]); 
    }
  
    // Wednesday
    if(selectedDay === 3) {
      timepicker.set('disable',[{ from: [8, 00], to: [17, 45] }]); 
    }
  
    // Thursday
    if(selectedDay === 4) {
      timepicker.set('disable',[{ from: [8, 00], to: [17, 45] }]); 
    }
  
    // Friday
    if(selectedDay === 5) {
      timepicker.set('disable',[{ from: [8, 00], to: [17, 45] }]);  
      timepicker.set('max', [19, 0])
    }
  
    // Saturday
    if(selectedDay === 6) {
      timepicker.set('disable',[{ from: [10, 15], to: [17, 40] }]); 
      timepicker.set('max', [20, 0])
    }
  
    // Sunday
    if(selectedDay === 0) {
      timepicker.set('min', [13, 0])
      timepicker.set('max', [15, 0])
    }
  }

  if (storeId === 4644) {
    
  }
  
	
}